import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import CheckOkButton from '../../components/atoms/CheckOkButton';
import CheckNgButton from '../../components/atoms/CheckNgButton';
import StripeButton from '../../components/atoms/StripeButton';
import CheckInvalidButton from '../../components/atoms/CheckInvalidButton';
import BackButton from '../../components/atoms/BackButton';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  subPaper: {
    position: 'relative',
    margin: 20,
    width: 'auto'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  help: {
    marginLeft: '18px',
    color: '#f00'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators({ getAccounts }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('shopId', 'setShopId', 0),
  withState('released', 'setReleased', false),
  withState('accountStatusAll', 'setAccountStatusAll', false),
  withState('accountStatusShop', 'setAccountStatusShop', false),
  withState('accountStatusStripe', 'setAccountStatusStripe', false),
  withState('accountStatusIdentity', 'setAccountStatusIdentity', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(data => {
        this.props.checkSession(data);
        if (data.payload.accountStatus != null) {
          this.props.setShopId(data.payload.shopId);
          this.props.setReleased(data.payload.accountStatus.status);
          this.props.setAccountStatusAll(data.payload.accountStatus.all);
          this.props.setAccountStatusShop(data.payload.accountStatus.shop);
          this.props.setAccountStatusStripe(
            data.payload.accountStatus.stripeAccount
          );
          this.props.setAccountStatusIdentity(
            data.payload.accountStatus.identity
          );
        }
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleRedirect,
    account,
    name,
    openDrawer,
    updateOpenDrawer,
    accountStatusShop,
    accountStatusStripe,
    accountStatusIdentity
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isDepositManageSelf =
      typeof account !== 'undefined' && account.depositManage === 'SELF';
    // const isDepositManageNonSelf =
    //   typeof account !== 'undefined' && account.depositManage === 'NONSELF';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    const backAction = () => handleRedirect('/release_step');
    return (
      <div className={classes.root}>
        <Header
          name={name}
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            開店処理
          </Typography>
          <Typography color="textSecondary">
            開店処理を行うことで、ごちめしサービスを利用開始できます。
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem} colSpan={2}>
                <Typography variant="h6" color="textSecondary">
                  開店処理に必要な登録手続きの状況
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗情報登録
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {accountStatusShop && <CheckOkButton />}
                {!accountStatusShop && <CheckNgButton />}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                本人確認情報登録
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {accountStatusIdentity && <CheckOkButton />}
                {!accountStatusIdentity && <CheckNgButton />}
              </TableCell>
            </TableRow>
            {isShop && account.paymentGroupType !== 'STRIPE' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  銀行連携
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {account.paymentGroupType === 'BANK' ? (
                    <>
                      <CheckOkButton />
                      {account.paymentGroupName && (
                        <div className={classes.textGroup}>
                          {`(${account.paymentGroupName})`}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {account.depositManage === 'NONSELF' && <CheckOkButton />}
                      {account.depositManage !== 'NONSELF' && <CheckNgButton />}
                    </>
                  )}
                </TableCell>
              </TableRow>
            )}
            {isShop && account.paymentGroupType !== 'BANK' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  Stripe情報登録（自社で入金管理）
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {account.paymentGroupType === 'STRIPE' ? (
                    <>
                      <CheckOkButton />
                      {account.paymentGroupName && (
                        <div className={classes.textGroup}>
                          {`(${account.paymentGroupName})`}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {account.depositManage === 'SELF' &&
                        account.accountStatus.stripeAccount && (
                          <CheckOkButton />
                        )}
                      {account.depositManage === 'SELF' &&
                        !account.accountStatus.stripeAccount && (
                          <CheckNgButton />
                        )}
                      {account.depositManage !== 'SELF' && (
                        <CheckInvalidButton />
                      )}
                    </>
                  )}
                </TableCell>
              </TableRow>
            )}
          </Table>
          {isShop &&
            isDepositManageSelf &&
            !accountStatusStripe &&
            !account.paymentGroupType && (
              <Table className={classes.detailTable}>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    <Typography color="textSecondary">
                      以下の Connect with Stripe ボタンを
                      押して、Stripeと接続してください
                    </Typography>
                    <StripeButton />
                    <br />
                    <div>
                      <Link
                        href={`${
                          process.env.PUBLIC_URL
                        }/others/stripe_regist.pdf`}
                        target="_blank"
                        className={classes.link}
                      >
                        登録手順はこちら
                      </Link>
                    </div>
                  </TableCell>
                </TableRow>
              </Table>
            )}
          {isShop && !isReleased && (
            <Table className={classes.detailTable}>
              <TableRow>
                <TableCell className={classes.tableCellData}>
                  <BackButton onClickAction={backAction} />
                </TableCell>
              </TableRow>
            </Table>
          )}
        </Paper>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
